import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";
import {InfoIcon} from "../../assets/svg-icons/InfoIcon";
import Checkbox from "@mui/material/Checkbox";

const RemindToPublishModal = observer(() => {
    const {modalStore, generalStore} = useStores();
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const procedureId = modalStore.modalData.remindToPublishProcedureId || "";

    const onEnter = () => {
        setDontShowAgain(false)
    }

    const confirmNotice = () => {
        if (!!dontShowAgain) {
            generalStore.turnOffRemindToPublish(procedureId);
        }
        modalStore.isRemindToPublishModalOpen = false;
        modalStore.resetModalData();
    }

    const renderRemindToPublishHeader = () => {
        return (
            <>
                <InfoIcon/>
                <h2>{generalStore.translate('notice')}</h2>
            </>
        )
    }

    const renderRemindToPublishBody = () => {
        return (
            <div>
                {generalStore.translate('rememberToPublishForChangesToBeVisible')}
            </div>
        )
    }

    const renderRemindToPublishFooter = () => {
        return (
            <>
                <Checkbox
                    checked={dontShowAgain}
                    onChange={() => setDontShowAgain(!dontShowAgain)}
                    name="dontShowRemindToPublishAgain"
                />
                <span className="checkbox-label">{generalStore.translate('dontShowThisMessageAgain')}</span>
            </>
        )
    }

    return (
        <GeneralDialog
            openControl='isRemindToPublishModalOpen'
            className='open-style-dialog'
            onEnter={onEnter}
            title={renderRemindToPublishHeader()}
            body={renderRemindToPublishBody()}
            isConfirmDisabled={false}
            onConfirm={confirmNotice}
            confirmText={generalStore.translate('ok')}
            buttonClass={"notification"}
            noCancel={true}
            dialogFooter={renderRemindToPublishFooter()}
        />
    );
})

export default RemindToPublishModal;
